import React, { Component } from "react";
import SimpleUploadImage from "../../../../modules/upload/SimpleUploadImage";
import SimpleCamera from "../../../../modules/SimpleCamera";

class FotoTab extends Component {
  render() {
    console.log(this.props);

    return (
      <div className="grid grid-2x gap-20px grid-mobile-none">
        <div id="grid-1">
          <SimpleCamera
            id="input_upload_engineNumberPhoto"
            name="engineNumberPhoto"
            label="Foto Gesekan"
            mandatory
            maxSizes={1}
            errorMessage={
              this.props.showErrors && !this.props.data?.engineNumberPhoto
                ? "Field belum diisi"
                : ""
            }
            enableUpload={true}
            compressed={true}
            value={this.props.data?.engineNumberPhoto}
            onChange={this.props.onChange}
          />
        </div>
        <div id="grid-2">
          {/* <SimpleUploadImage
            category={this.props.done ? "" : "upload"}
            id="input_upload_frameNumberPhoto"
            name="frameNumberPhoto"
            label="Nomor Rangka"
            containerclassname="flex-1"
            disabled={this.props.done}
            value={this.props.data?.frameNumberPhoto}
            onChange={this.props.onChange}
          /> */}
        </div>
      </div>
    );
  }
}

export default FotoTab;
